var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 9.167c-1.56 0-4.667.78-4.667 2.333v1.167h9.334V11.5c0-1.553-3.107-2.333-4.667-2.333m-3.107 2.167c.56-.387 1.914-.834 3.107-.834s2.547.447 3.107.834zM6.5 8a2.336 2.336 0 0 0 2.333-2.333A2.336 2.336 0 0 0 6.5 3.334a2.336 2.336 0 0 0-2.333 2.333A2.336 2.336 0 0 0 6.5 8m0-3.333c.553 0 1 .447 1 1s-.447 1-1 1-1-.447-1-1 .447-1 1-1m4.693 4.54c.774.56 1.307 1.306 1.307 2.293v1.167h2.667V11.5c0-1.347-2.334-2.113-3.974-2.293M10.5 8a2.336 2.336 0 0 0 2.333-2.333A2.336 2.336 0 0 0 10.5 3.334c-.36 0-.693.086-1 .233.42.593.667 1.32.667 2.1s-.247 1.507-.667 2.1c.307.146.64.233 1 .233"
  })));
};
export default SvgPeople;